import { ENDPOINT } from 'api/endPoints/getScheduleDelay';

import { NoPermissionMessage } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.contants';
import { IHashmapItemComponentProps } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import { SMALL } from 'components/Dashboards/Reporting/reportingConfig';

export const scheduleDelay: IHashmapItemComponentProps = {
    NoPermissionMessage,
    componentKey: 'scheduleDelay',
    title: 'Schedule Delay',
    id: 'scheduleDelay',
    globalFiltersConfig: [
        { key: 'wbs', name: 'wbs', defaultValue: null },
        { key: 'tags', name: 'tags', defaultValue: [] },
        { key: 'activityCodes', name: 'activityCodes', defaultValue: [] },
        { key: 'milestoneFragnet', name: 'milestoneFragnet', defaultValue: null },
    ],
    reportStyle: {
        widgetSizesAvailable: {
            small: SMALL,
        },
        widgetInitialSize: SMALL,
    },
    reportConfig: {
        buttons: {
            narrative: false,
        },
        threeDotMenuOptions: {
            useAutomatedNarrative: false,
        },
        hideNarrativeEditor: false,
    },
    endpoint: ENDPOINT,
};
